'use client';

import { FC } from 'react';

export interface TextAreaProps {
    id?: string;
    name?: string;
    disabled?: boolean;
    error?: boolean;
    placeholder?: string;
    onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
    value: string;
    testId: string;
    extendedClassName?: string;
    maxLength?: number;
}

const TextArea: FC<TextAreaProps> = (props) => {
    const { id = '', name = '', disabled = false, error = false } = props;

    const defaultClassName =
        'textarea text-[100%] leading-relaxed bg-white px-[12px] py-[6px] border rounded text-gray-900 block font-normal bg-clip-padding focus:outline-none focus:border-[#86b7fe] focus:shadow-[inset_0_1px_1px_rgba(0,0,0,0.08),0_0_8px_rgba(102,175,233,0.6)]';

    // Error
    let errorClassName = '';
    if (error) {
        errorClassName =
            'textarea-error focus:border-red-500 focus:shadow-[inset_0_1px_1px_rgba(0,0,0,0.08),0_0_8px_rgba(255,99,71,0.6)]';
    }

    let disabledClass = '';
    if (disabled) {
        disabledClass =
            'disabled:!border-custom-gray-06 disabled:bg-custom-gray-07 disabled:text-custom-black-01 disabled:opacity-100';
    }

    const textAreaClassNames = [defaultClassName, props.extendedClassName, errorClassName, disabledClass].join(' ');

    return (
        <textarea
            id={id}
            name={name}
            disabled={disabled}
            placeholder={props.placeholder}
            onChange={props.onChange}
            value={props.value}
            data-test-id={props.testId}
            className={textAreaClassNames}
            maxLength={props.maxLength}
        />
    );
};

export default TextArea;
